/* eslint-disable camelcase */
/* eslint-disable ordered-imports/ordered-imports */
import CrossIcon from "@NA/Icons/CrossIcon";
import MyBranchState from "@NA/Store/Data/ADIMyBranchState";
import ADIColors from "@NA/Utils/ADIColors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import translate from "@insite/client-framework/Translate";
import {
    AccordionSectionPresentationProps,
    ManagedAccordionSection
} from "@insite/mobius/AccordionSection";
import Checkbox, {
    CheckboxPresentationProps,
    StyleProps as CheckboxStyleProps,
} from "@insite/mobius/Checkbox/Checkbox";
import CheckboxGroup, { CheckboxGroupProps } from "@insite/mobius/CheckboxGroup/CheckboxGroup";
import Link, { LinkPresentationProps } from "@insite/mobius/Link/Link";
import { ModalPresentationProps } from "@insite/mobius/Modal";
import { TypographyProps } from "@insite/mobius/Typography";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { Typography } from "@insite/mobius/index";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import getColor from "@insite/mobius/utilities/getColor";
import React, { FC, useEffect, useState } from "react";
import { css } from "styled-components";

import { 
    RegularFacet, 
    RegularFacetState, 
    RegularFacetValue, 
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
} from "@coveo/headless/commerce";
import { HasCoveoHooks, withCoveoHooks } from "@NA/Components/Coveo/Contexts/CoveoHooksContext";

export interface ProductListFilterAccordionSectionStyles {
    accordionSection?: AccordionSectionPresentationProps;
    checkBoxGroup?: CheckboxGroupProps;
    checkBox?: CheckboxPresentationProps;
    checkBoxSelected?: CheckboxPresentationProps;
    seeMoreLink?: LinkPresentationProps;
    seeLessLink?: LinkPresentationProps;
    title?: TypographyProps;
    count?: TypographyProps;
    filterText?: TypographyProps;
    myBranchWrapper?: InjectableCss;
    myBranchName?: TypographyProps;
    changeBranchLinkGrid?: InjectableCss;
    changeBranchLink?: TypographyProps;
    changeBranchModal?: ModalPresentationProps;
    iconTextWrapper?: InjectableCss;
    branchTxt?: TypographyProps;
}

export const productListFilterAccordionSectionStyles: ProductListFilterAccordionSectionStyles = {
    accordionSection: {
        panelProps: {
            css: css`
                overflow-y: auto;
                overflow-x: hidden;
                max-height: 350px;
            `,
        },

        headerProps: {
            css: css`
            > button {
                svg {
                height: 18px;
                width: 18px;
                stroke-width: 2.5px;
                } 
            }
            `
        },
    },
    checkBoxGroup: {
        css: css`
            width: 100%;
            &:not(:last-child) {
                padding-bottom: 5px;
            }
        `,
    },
    checkBox: {
        css: css<CheckboxStyleProps>`
            align-items: center;
            span[role="checkbox"] + label {
                display: flex;
                align-items: baseline;
            }
            span[role="checkbox"] {
                height: 18px;
                min-width: 18px;
                cursor: pointer;
                border-radius: 2px;
                border: 2px solid #DDDDDD;
                position: relative; 
                top: -3px;

             &:focus {
                    box-shadow: none !important;
                 }
                ${({ _sizeVariant }) =>
                _sizeVariant === "small"
                    ? css`
                              margin-top: 5px;
                          `
                    : css`
                              margin-top: 4px;
                          `}
            }
        `,
        typographyProps: {
            css: css`
                word-break: break-word;
            `,
        },
    },
    checkBoxSelected: {
        css: css<CheckboxStyleProps>`
            align-items: center;
            span[role="checkbox"] {
                 height: 18px !important;
                 min-width: 18px !important;
                 cursor: pointer;
                 border-radius: 2px;
                 position: relative;
                 top: -3px;

                 &:focus {
                    box-shadow: none !important;
                 }
                ${({ _sizeVariant }) =>
                _sizeVariant === "small"
                    ? css`
                              margin-top: 5px;
                          `
                    : css`
                              margin-top: 4px;
                          `}
            }
        `,
        typographyProps: {
            css: css`
                word-break: break-all;
            `,
            weight: "bold",
        },
    },
    seeMoreLink: {
        css: css`
            padding-top: 5px;
            padding-right: 10px;
        `,
    },
    seeLessLink: {
        css: css`
            padding-top: 5px;
        `,
    },
    title: {
        css: css`
            font-size: ${getProp("theme.typography.headerSecondary.size")};
            color: ${getColor("text.main")};
        `,
    },
    count: {
        css: css`
            background-color: ${getColor("text.disabled")};
            border-radius: 4px;
            padding: 2px 3px;
            color: #666;
            margin-left: 5px;
            min-width: max-content;
        `,
    },
    myBranchWrapper: {
        css: css`
            margin: 0 0 10px 30px;
        `,
    },
    myBranchName: {
        size: 14,
        weight: "bold",
        color: ADIColors.black,
    },
    changeBranchLinkGrid: {
        css: css`
            order: initial;
            margin-bottom: 0;
            ${({ theme }: { theme: BaseTheme; }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css``,
                        css``,
                        css`
                            order: 4;
                            margin-bottom: 20px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
            > span {
                margin-right: 10px;
            }
        `,
    },
    changeBranchLink: {
        css: css`
            font-size: ${getProp("theme.typography.h6.size")};
            margin-left: 10px;
            a:hover {
                text-decoration: underline;
            }
            span {
                font-size: ${getProp("theme.typography.h6.size")};
                display: inline;
                margin-top: 0px;
                ${({ theme }: { theme: BaseTheme; }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                                font-size: ${getProp("theme.typography.headerSecondary.size")};
                                display: block;
                                margin-top: 6px;
                            `,
                        css``,
                        css``,
                        null,
                        null,
                    ],
                    "max",
                )}
            }
        `,
    },
    changeBranchModal: {
        sizeVariant: "large",
        closeButtonIconProps: {
            src: CrossIcon,
            size: 20,
        },
        cssOverrides: {
            modalBody: css`
                max-width: 750px !important;
                border-radius: 4px;
                padding: 28px !important;
            `,
            modalContent: css`
                padding: 0;
            `,
            modalTitle: css`
                border-bottom: 0;
                padding: 0 !important;
                margin-bottom: 20px;
                > h4 {
                    font-size: 16px;
                    font-weight: bold;
                    font-family: "Nunito Sans", sans-serif;
                    line-height: normal;
                    color: ${ADIColors.black2};
                }
                button {
                    border-radius: 0;
                    svg {
                        height: 20px;
                    }
                }
            `,
            headlineTypography: css`
                font-size: 20px;
                margin-bottom: 0;
            `,
        },
    },
    iconTextWrapper: {
        css: css`
            display: flex;
            padding: 7px;
        `,
    },
    branchTxt: {
        size: 14,
        weight: 700,
        color: ADIColors.darkBlue1,
        css: css`
            line-height: normal;
            margin: 5px 0 0 10px;
        `,
    },
};

export interface Props {
    onChangeFacet: (value: RegularFacetValue) => void;
    extendedStyles?: ProductListFilterAccordionSectionStyles;
    myBranchDetails?: MyBranchState;
    isAuthenticated?: boolean;
    canShowMoreValues: boolean;
    facetState: RegularFacetState;
    facet: RegularFacet;
}

const CoveoFacetAccordionContainer: FC<Props & HasCoveoHooks> = ({
    onChangeFacet,
    extendedStyles,  
    facetState,
    facet,
    productList,
}) => {

    const [isOpen, setIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    
    useEffect(() => {
        if(!productList.state?.isLoading) {
            setIsLoading(false);
        }
    }, [productList.state?.isLoading]);
    
    const anySelected = facetState.values.find((f:RegularFacetValue) => f.state === 'selected') !== undefined;
    const [styles] = useState(() => mergeToNew(productListFilterAccordionSectionStyles, extendedStyles));
    
    const initExpanded = () => {
        switch (facetState.facetId) {
            case "ec_availability":
            case "ec_brand":
            case "ec_category_name":
            case "ec_product_type":
                return true;
            default:
                return false;
        }
    };
    
    return (
        <ManagedAccordionSection
            title={
                <StyledWrapper>
                    <Typography {...styles.title}>
                        {
                            facetState.displayName === "Brand" ? "Brand Name" : facetState.displayName
                        }
                    </Typography>
                    <Typography>&nbsp;</Typography>
                </StyledWrapper>
            }
            {...styles.accordionSection}
            initialExpanded={isOpen || initExpanded() || anySelected}
            onTogglePanel={() => setIsOpen(!isOpen)}
        >
            {facetState.values?.map((value: RegularFacetValue) => (
                <CheckboxGroup key={value.value} {...styles.checkBoxGroup}>
                    <Checkbox
                        {...(value.state === 'selected' ? styles.checkBoxSelected : styles.checkBox)}
                        checked={value.state === 'selected'}
                        onChange={() => onChangeFacet(value)}
                        data-test-selector={`valueFilter${value.value}`}
                    >
                        {value.value}
                        {value.numberOfResults !== -1 && (
                            <Typography {...styles.count}>{value.numberOfResults}</Typography>
                        )}
                    </Checkbox>
                </CheckboxGroup>
            ))}

            {facetState.canShowMoreValues && (
                <Link
                    {...styles.seeMoreLink}
                    onClick={() => {
                        facet.showMoreValues();
                        setIsLoading(true);
                        setIsOpen(true);
                    }}
                >
                    {translate("See More")}
                </Link>
            )}

            {facetState.canShowLessValues  && (
                <Link
                    {...styles.seeLessLink}
                    onClick={() => {
                        facet.showLessValues();
                        setIsLoading(true);
                    }}
                >
                    {translate(" See Less")}
                </Link>
            )}
        </ManagedAccordionSection>
    );
};

export default withCoveoHooks(CoveoFacetAccordionContainer);
